module.exports = require("next/dist/server/app-render/work-async-storage.external.js");